<template>
  <div class="failure-analysis">
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        <a-select
          :options="projectOptions"
          v-model:value="requestPayload.projectLifeCycleId"
          @change="handleSelectProject"
          placeholder="请选择项目"
          style="width: 200px"
          allowClear
        >
        </a-select>

        <select-state
          type="processes"
          :value="requestPayload.productionProcesses"
          placeholder="工序"
          @handleSelect="handleSelect"
          style="width: 160px"
        ></select-state>
      </a-space>

      <a-button
        @click="handleInsertAnalysis(null)"
        :disabled="!isInsertAuthority"
        >新增</a-button
      >
    </div>

    <analysis-form
      ref="analysifFormRef"
      @updateTable="handleSearch"
    ></analysis-form>

    <a-table
      :data-source="table.data"
      bordered
      :pagination="false"
      :columns="columns"
      rowKey="id"
      :scroll="{
        x: 'calc(100vw - 300px)',
        y: 'calc(100vh - 410px)',
      }"
    >
      <template #action="{ record }">
        <a-space>
          <a-button
            type="primary"
            @click="handleUpdateFailurea(record)"
            size="small"
            :disabled="!actionAuthority(record)"
            >修改</a-button
          >
          <a-button
            type="warning"
            danger
            @click="handleDelete(record)"
            size="small"
            :disabled="!actionAuthority(record)"
          >
            删除
          </a-button>
        </a-space>
      </template></a-table
    >

    <div class="df both-side" style="margin-top: 10px">
      <div></div>
      <a-pagination
        size="small"
        :total="table.total"
        :show-total="(total) => `共 ${total} 条`"
        show-size-changer
        show-quick-jumper
        v-model:current="table.pageNum"
        v-model:lineNum="table.lineNum"
        @change="hanldeUpdatePageNum"
        @showSizeChange="hanldeUpdatePageNum"
      />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { useTable } from "@/views/notice/serve/table";
import { getProjectLifeCycle } from "@/request/view/project";
import {
  getPfmeaList,
  deletePfmea,
} from "@/request/view/trialProductionCenter";
import analysisForm from "@/views/trialProductionCenter/failureanalysis/form.vue";
import selectState from "@/views/trialProductionCenter/failureanalysis/component/selectState.vue";
import { Toast } from "@/utils";
import { useStore } from "vuex";

export default defineComponent({
  components: { analysisForm, selectState },
  setup() {
    const router = useRouter();

    const user = useStore().state.user.user;

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
      hanldeUpdatePageNum,
    } = useTable();

    initPayload({
      productionProcesses: null,
      projectLifeCycleId: null,
    });

    const columns = [
      {
        title: "序号",
        dataIndex: "id",
        align: "center",
        width: "50px",
        fixed: "left",
      },
      {
        title: "工序",
        dataIndex: "productionProcesses",
        align: "center",
        width: "80px",
        fixed: "left",
      },
      {
        title: "过程功能",
        dataIndex: "processFunction",
        align: "center",
        width: "180px",
        fixed: "left",
      },
      {
        title: "记录日期",
        dataIndex: "localDate",
        align: "center",
        width: "120px",
      },
      {
        title: "要求",
        dataIndex: "requirement",
        align: "center",
        width: "120px",
      },
      {
        title: "失效模式",
        dataIndex: "failureMode",
        align: "center",
        width: "120px",
      },
      {
        title: "失效影响",
        dataIndex: "failureEffect",
        align: "center",
        width: "120px",
      },
      {
        title: "严重性",
        dataIndex: "seriousness",
        align: "center",
        width: "30px",
      },
      {
        title: "失效原因",
        dataIndex: "failureCause",
        align: "center",
        width: "120px",
      },
      {
        title: "现行控制过程",
        children: [
          {
            title: "控制预防",
            dataIndex: "controlAndPrevention",
            align: "center",
            width: "120px",
          },
          {
            title: "发生频率",
            dataIndex: "frequency",
            align: "center",
            width: "30px",
          },
          {
            title: "控制探测",
            dataIndex: "controlDetection",
            align: "center",
            width: "110px",
          },
          {
            title: "可探测度",
            dataIndex: "detectability",
            align: "center",
            width: "30px",
          },
        ],
      },

      {
        title: "RPN",
        dataIndex: "expireRPN",
        align: "center",
        width: "40px",
      },
      {
        title: "建议",
        dataIndex: "suggestedMeasures",
        align: "center",
        width: "110px",
      },
      {
        title: "责任人",
        dataIndex: "personResponsible",
        align: "center",
        width: "110px",
      },
      {
        title: "目标完成日期",
        dataIndex: "completionDate",
        align: "center",
        width: "160px",
      },
      {
        title: "采取行动",
        dataIndex: "takeAction",
        align: "center",
        width: "160px",
      },
      {
        title: "行动结果",
        children: [
          {
            title: "生效日期",
            dataIndex: "effectiveDate",
            align: "center",
            width: "120px",
          },
          {
            title: "严重性",
            dataIndex: "resultsSeriousness",
            align: "center",
            width: "30px",
          },
          {
            title: "发生频度",
            dataIndex: "resultsFrequency",
            align: "center",
            width: "30px",
          },
          {
            title: "可探测度",
            dataIndex: "resultsDetectability",
            align: "center",
            width: "30px",
          },
          {
            title: "RPN",
            dataIndex: "actRPN",
            align: "center",
            width: "40px",
          },
        ],
      },

      {
        title: "操作",
        align: "center",
        width: "140px",
        fixed: "right",
        slots: {
          customRender: "action",
        },
      },
    ];

    requestConfig.pull_fn = getPfmeaList;
    requestConfig.delete_fn = deletePfmea;

    const analysifFormRef = ref();

    const projectInfo = reactive({
      projectId: null,
      projectName: null,
    });

    const handleUpdateFailurea = (record) => {
      analysifFormRef.value.showModal({
        type: "update",
        title: "修改过程分析",
        data: record,
      });
    };

    const handleInsertAnalysis = () => {
      analysifFormRef.value.showModal({
        type: "insert",
        title: "新增过程分析",
        data: projectInfo,
      });
    };

    const handleProjectDetails = (record) => {
      console.log(record);
    };

    // const option.

    const projectOptions = reactive([]);

    const getProjectOptions = () => {
      projectOptions.length = 0;
      getProjectLifeCycle().then((res) => {
        if (res.code === 200 && res.message === "成功") {
          res.data.forEach((item) => {
            projectOptions.push({
              label: item.project,
              value: item.id,
            });
          });

          console.log(projectOptions);
        }
      });
    };

    const isInsertAuthority = computed(
      () => projectInfo.projectId && projectInfo.projectName
    );

    const getData = () => {
      getListData().then((res) => {
        table.data.forEach((item) => {
          if (item.seriousness && item.detectability && item.frequency) {
            item.expireRPN =
              item.seriousness * item.detectability * item.frequency;
          }

          if (
            item.resultsFrequency &&
            item.resultsDetectability &&
            item.resultsSeriousness
          ) {
            item.actRPN =
              item.resultsFrequency *
              item.resultsDetectability *
              item.resultsSeriousness;
          }
        });
      });
    };

    const handleDelete = (record) => {
      deleteRecords([record.id], {
        title: "确认删除？",
      }).then((res) => {
        getData();
      });
    };
    const handleSelectProject = (e, option) => {
      projectInfo.projectId = null;
      projectInfo.projectName = null;
      if (option) {
        projectInfo.projectId = option.value;
        projectInfo.projectName = option.label;
      }
      getData();
    };
    const handleSelect = (e) => {
      requestPayload.productionProcesses = e;
      console.log(e);
      getData();
    };

    getData();

    getProjectOptions();

    const handleSearch = () => {
      table.pageNum = 1;
      getData();
    };

    const actionAuthority = (record) => {
      const isInserter = record.username === user.nickName;

      const isproduceLeader = user.structureId === 21 && user.isDL;
      return isInserter || isproduceLeader;
    };

    return {
      table,
      columns,
      analysifFormRef,
      isInsertAuthority,
      requestPayload,
      handleProjectDetails,
      handleUpdateFailurea,
      handleDelete,
      handleSelect,
      handleInsertAnalysis,
      handleSelectProject,
      projectOptions,
      hanldeUpdatePageNum,
      handleSearch,
      actionAuthority,
    };
  },
});
</script>

<style lang="less" scoped>
.failure-analysis {
  background: #fff;
  width: 100%;
  height: calc(100vh - 120px);
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 20px;
  padding: 15px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 16px 4px;
}

:deep(.ant-table-tbody > tr > td) {
  padding: 10px 4px;
}
</style>
